import React, { lazy, Suspense } from 'react';
import { Spin } from 'antd';

// The dashboard's Cart tab is not shown on first load, so its table/filter are split out of the
// main bundle (AB#2926). These wrappers are drop-in replacements for the default exports.
const LazyCartTable = lazy(() => import('@/pages/cart-management/cart.table'));
const LazyCartFilter = lazy(() => import('@/pages/cart-management/cart.filter'));

const CartFallback = () => (
    <div className="display-center" style={{ justifyContent: 'center', padding: 24 }}>
        <Spin />
    </div>
);

export const CartTable = (props) => (
    <Suspense fallback={<CartFallback />}>
        <LazyCartTable {...props} />
    </Suspense>
);

export const CartFilter = (props) => (
    <Suspense fallback={<CartFallback />}>
        <LazyCartFilter {...props} />
    </Suspense>
);
